export const escapeCsvField = (field) => {
  if (field == null) {
    return ''
  }
  let stringField = String(field)

  // Enclosing special characters in double quotes
  if (stringField.includes(';') || stringField.includes('"') || stringField.includes('\n') || stringField.includes('\r')) {
    stringField = stringField.replace(/"/g, '""')
    return `"${stringField}"`
  }

  return stringField
}
